// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VSYEm","colMin":"styles_colMin__Vr5TC"};